var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6084_21110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6084_21110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3338 54.167C54.8616 54.167 51.9102 52.9517 49.4797 50.5212C47.0491 48.0906 45.8338 45.1392 45.8338 41.667C45.8338 38.1948 47.0491 35.2434 49.4797 32.8128C51.9102 30.3823 54.8616 29.167 58.3338 29.167C61.8061 29.167 64.7575 30.3823 67.188 32.8128C69.6186 35.2434 70.8338 38.1948 70.8338 41.667C70.8338 45.1392 69.6186 48.0906 67.188 50.5212C64.7575 52.9517 61.8061 54.167 58.3338 54.167ZM29.1672 66.667C26.8755 66.667 24.9137 65.851 23.2818 64.2191C21.6498 62.5871 20.8338 60.6253 20.8338 58.3337V25.0003C20.8338 22.7087 21.6498 20.7469 23.2818 19.1149C24.9137 17.483 26.8755 16.667 29.1672 16.667H87.5005C89.7922 16.667 91.754 17.483 93.3859 19.1149C95.0179 20.7469 95.8338 22.7087 95.8338 25.0003V58.3337C95.8338 60.6253 95.0179 62.5871 93.3859 64.2191C91.754 65.851 89.7922 66.667 87.5005 66.667H29.1672ZM37.5005 58.3337H79.1672C79.1672 56.042 79.9832 54.0802 81.6151 52.4482C83.247 50.8163 85.2088 50.0003 87.5005 50.0003V33.3337C85.2088 33.3337 83.247 32.5177 81.6151 30.8857C79.9832 29.2538 79.1672 27.292 79.1672 25.0003H37.5005C37.5005 27.292 36.6845 29.2538 35.0526 30.8857C33.4206 32.5177 31.4588 33.3337 29.1672 33.3337V50.0003C31.4588 50.0003 33.4206 50.8163 35.0526 52.4482C36.6845 54.0802 37.5005 56.042 37.5005 58.3337ZM83.3338 83.3337H12.5005C10.2088 83.3337 8.24704 82.5177 6.61509 80.8857C4.98315 79.2538 4.16718 77.292 4.16718 75.0003V29.167H12.5005V75.0003H83.3338V83.3337Z",
    fill: "#001E2B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/Payroll.4e787c8553fd327142311a802c072d4a.svg";
export { ForwardRef as ReactComponent };